// extracted by mini-css-extract-plugin
export default {"buttons":"ProductDetailsButtons_buttons__+3CAt","wishlist":"ProductDetailsButtons_wishlist__QPNdi"};